export const contactConsts = {
  GET_CONTACT: "GET_CONTACT",
  UPDATE_CONTACT: "UPDATE_CONTACT"
};